module.exports = __webpack_public_path__ + "img/stories-desktop-arabic.466a77ef.png";